import { api, formatApiError } from './api';

export const FREQUENCY_OPTIONS = [
  'once daily',
  'twice daily',
  'three times daily',
  'four times daily',
  'as needed',
  'custom',
];

export async function listMedications() {
  try {
    const { data } = await api.get('/medications');
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getMedication(id) {
  try {
    const { data } = await api.get(`/medications/${id}`);
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function createMedication(input) {
  try {
    const { data } = await api.post('/medications', input);
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function updateMedication(id, patch) {
  try {
    const { data } = await api.put(`/medications/${id}`, patch);
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function deleteMedication(id) {
  try {
    await api.delete(`/medications/${id}`);
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function seedDemoMedications() {
  try {
    const { data } = await api.post('/medications/seed-demo');
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function searchDrugs(q, limit = 8) {
  if (!q.trim()) return [];
  try {
    const { data } = await api.get('/drugs/search', { params: { q, limit } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function lookupNDC(ndc) {
  if (!ndc.trim()) return null;
  try {
    const { data } = await api.get('/drugs/by-ndc', { params: { ndc } });
    return data;
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw new Error(formatApiError(err));
  }
}
